'use client'
import { TurnkeySolanaWalletConnectors } from '@dynamic-labs/embedded-wallet-solana';
import { Phantom } from './Phantom.js';
import { injectedWalletOverrides, fetchInjectedWalletConnectors } from './injected/fetchInjectedWalletConnectors.js';
import { UnknownInjected } from './injected/UnknownInjected.js';
import { FallbackSolanaConnector } from './injected/FallbackSolanaConnector.js';

const SolanaWalletConnectors = (props) => [
    ...injectedWalletOverrides,
    ...fetchInjectedWalletConnectors(props),
    ...TurnkeySolanaWalletConnectors(props),
    Phantom,
    UnknownInjected,
    FallbackSolanaConnector,
];

export { SolanaWalletConnectors };
